<template>
  <div class="ma-4">
    <ProgramNav :programID="$route.params.programID" />
    <v-row dense>
      <v-col cols="12">
        <FormTable :title="title" :program-id="$route.params.programID" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ProgramNav from "@/components/ProgramNav";
import FormTable from "./FormTable";

export default {
  components: {
    ProgramNav,
    FormTable,
  },
  data: () => ({
    title: "Water Temperature Tracking",
  }),
};
</script>
